
    import { Component, Vue, Prop, Watch } from 'vue-facing-decorator';
    
    @Component({
        emits: ['save'],
    })
    export default class CloseLocation extends Vue {
        @Prop({ default: null }) public location: any;
        @Prop({ default: null }) public model: any;
        @Prop({ default: null }) public scenario: any;

        private modalShow = false;
        private menu = false;
        private valid = false;
       
        private mounted() {
            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape") {
                    if (this.modalShow) this.cancel();
                }
            });
        }

        @Watch('location')
        private onLocationChanged(value: any) {
            if (value) this.modalShow = true; else this.modalShow = false;
        }

        private save(scenarioCreation: any) {
            const fieldsToValidate: Array<any> = [];
            (this.$refs.form as any).validate();
            fieldsToValidate.forEach((fieldRef) => {
            const field = this.$refs[fieldRef] as any;
                if (field && field.validate) {
                    const isValid = field.validate();
                    if (!isValid) field.$el.scrollIntoView({ behavior: 'smooth' });
                }
            });
            if (this.valid) {
                this.location['scenarioCreation'] = scenarioCreation;
                this.$emit('save', this.location );
            }
        }

        private async cancel() {
            this.modalShow = false;
        }

        private toggleMenu() {
            this.menu = !this.menu;
        }
    }
